import { logEvent } from './supabase';

/** Analytics events for ImageMotion activation / conversion. No PII. */
export type ImagemotionAnalyticsEvent =
  | 'imagemotion_page_viewed'
  | 'imagemotion_demo_played'
  | 'imagemotion_signup_completed'
  | 'imagemotion_tester_viewed'
  | 'imagemotion_tester_selected'
  | 'imagemotion_package_selected'
  | 'imagemotion_images_uploaded'
  | 'imagemotion_creation_started'
  | 'imagemotion_creation_completed'
  | 'imagemotion_creation_failed'
  | 'double_credit_offer_viewed'
  | 'double_credit_offer_selected'
  | 'double_credit_checkout_started'
  | 'double_credit_offer_purchased'
  | 'double_credit_offer_dismissed'
  | 'tester_conversion_viewed'
  | 'tester_full_video_clicked'
  | 'rehub_app_suggestion_clicked'
  | 'buy_credits_clicked'
  | 'buy_credits_panel_opened'
  | 'credit_pack_viewed'
  | 'credit_pack_selected'
  | 'credit_checkout_started'
  | 'credit_purchase_completed'
  | 'credit_purchase_failed'
  | 'credit_currency_changed'
  | 'custom_credit_purchase_selected'
  | 'staging_animation_opened'
  | 'staging_animation_before_uploaded'
  | 'staging_animation_after_uploaded'
  | 'staging_animation_started'
  | 'staging_animation_completed'
  | 'staging_animation_failed'
  | 'staging_animation_downloaded';

export type CreditBalanceRange = '0' | '1-9' | '10-14' | '15-24' | '25-49' | '50+';

export function creditBalanceRange(credits: number): CreditBalanceRange {
  if (credits <= 0) return '0';
  if (credits < 10) return '1-9';
  if (credits < 15) return '10-14';
  if (credits < 25) return '15-24';
  if (credits < 50) return '25-49';
  return '50+';
}

export interface ImagemotionAnalyticsProps {
  package_id?: string;
  pack_id?: string;
  credits?: number;
  image_count?: number;
  credit_balance_range?: CreditBalanceRange;
  user_segment?: 'new' | 'returning';
  tester_eligible?: boolean;
  offer_eligible?: boolean;
  offer_tier?: string;
  currency?: 'GBP' | 'USD';
  source?: string;
  app_source?: string;
  purchase_type?: string;
  [key: string]: string | number | boolean | undefined;
}

/** Fire-and-forget analytics. Never throws. */
export function trackImagemotionEvent(
  event: ImagemotionAnalyticsEvent,
  userId?: string | null,
  props: ImagemotionAnalyticsProps = {}
): void {
  const metadata: Record<string, unknown> = { app: 'imagemotion' };
  for (const [key, value] of Object.entries(props)) {
    if (value !== undefined) metadata[key] = value;
  }
  void logEvent(event as any, userId ?? null, null, null, null, metadata).catch(() => {});
}
